function hasScope(scopes, scope) {
  return scopes && scopes.includes(scope);
}
export const hasTeamHierarchies = scopes => hasScope(scopes, 'teams-advanced-modeling-access');
const portalHasContentPartitioning = scopes => hasScope(scopes, 'sales-content-partitioning');
const userHasContentPartitioning = scopes => hasScope(scopes, 'sales-content-team-sharing') || hasScope(scopes, 'sales-content-admin-write') || hasScope(scopes, 'super-admin');
export const canAssignContent = scopes => userHasContentPartitioning(scopes) && portalHasContentPartitioning(scopes);